<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="dialog"
      lazy
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="utilityFile" class="white--text"
            >Lista
            {{
              utilityFile.power_plant_id.toUpperCase() +
              " - " +
              utilityFile.expected_competence
            }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <!-- <v-toolbar-items>
                        <v-btn dark flat @click="dialog = false">Save</v-btn>
                    </v-toolbar-items> -->
        </v-toolbar>

        <v-container v-if="!itemLoading">
          <v-layout wrap>
            <v-flex sm4 xs12 md4 lg4>
              <material-stats-card
                color="green"
                icon="mdi-account-multiple-outline"
                title="Percentual de Ocupação"
                :value="sumItemsPercentage.toFixed(5)"
                small-value="%"
                sub-icon="mdi-account-circle"
                :sub-text="fileItems.length.toString() + ' membros'"
              />
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer />
            <!-- <v-btn color="primary" small outline slot="start" @click="dialogEvent()">
                            <v-icon left>event</v-icon>Salvar Envio
                        </v-btn> -->
            <v-btn
              color="primary"
              small
              outline
              slot="start"
              :loading="loading_export"
              :disabled="loading_export"
              @click="_export(fileItems)"
            >
              <v-icon left>mdi-file-excel</v-icon>Exportar
            </v-btn>
          </v-layout>
          <!-- <v-data-table
                        :headers="headers"
                        :items="fileItems"
                        class="elevation-0"
                        :search="search"
                        total-items=100
                        :rows-per-page-items="[50,100,200,{'text':'Todos','value':-1}]"
                    > -->
          <v-data-table
            :headers="headers"
            :items="fileItems"
            class="elevation-0"
            :search="search"
            :pagination.sync="pag"
          >
            <template v-slot:items="props">
              <td>{{ props.item.consumer_unit }}</td>
              <td>{{ props.item.customer_number }}</td>
              <td class="text-xs-right">{{ props.item.percentage }}%</td>
              <td class="text-xs-right">
                {{ props.item.last_percentage || 0 }}%
              </td>
              <td class="text-xs-right">{{ props.item.balance }}</td>
              <td>
                <v-chip
                  small
                  :color="props.item.status | formatFileItemStatusColor"
                  text-color="white"
                  >{{ props.item.status | formatFileItemStatus }}</v-chip
                >
              </td>
              <td class="text-xs-right">{{ props.item.operation }}</td>
              <td class="text-xs-right">
                {{ props.item.qtdeinadimplencia || 0 }}
              </td>
              <td class="text-xs-right">
                R$ {{ props.item.valorinadimplencia || 0 | formatCurrency }}
              </td>

              <td class="justify-center layout px-0">
                <v-icon small class="mr-2" @click="editItem(props.item)">
                  edit
                </v-icon>
                <v-icon small @click="deleteItem(props.item)"> delete </v-icon>
              </td>
            </template>
            <!-- <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">Reset</v-btn>
                        </template> -->
          </v-data-table>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_edit" max-width="500px">
      <!-- <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
            </template> -->
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.consumer_unit"
                  readonly
                  label="Unidade Consumidora"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model.number="editedItem.percentage"
                  label="Percentual"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <!-- <v-text-field v-model="editedItem.status" label="Status"></v-text-field> -->
                <v-combobox
                  v-model="editedItem.status"
                  :items="statusItems"
                  item-text="label"
                  item-value="value"
                  label="Informe o status"
                  :return-object="false"
                ></v-combobox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" flat @click="save">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_event" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Novo registro</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="eventDate"
                  label="Data"
                  return-masked-value
                  mask="##/##/####"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-combobox
                  v-model="eventName"
                  :items="['Envio']"
                  item-text="label"
                  item-value="value"
                  label="Evento"
                  :return-object="false"
                ></v-combobox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog_event = false"
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" flat @click="saveEvent">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { eventBus } from "../../main";
// import { getConsumerUnit } from '../../services/consumer_units'
import XLSX from "xlsx";
export default {
  data: () => ({
    dialog: false,
    dialog_edit: false,
    dialog_event: false,
    utilityFile: null,
    search: "",
    headers: [
      {
        text: "Unidade Consumidora",
        align: "left",
        value: "consumer_unit",
      },
      { text: "Num Cliente", value: "customer_number" },
      { text: "Percentual", value: "percentage", align: "right" },
      { text: "Percentual Anterior", value: "percentage", align: "right" },
      { text: "Saldo", value: "balance", align: "right" },
      { text: "Status", value: "status" },
      { text: "Operação", value: "operation", align: "right" },
      {
        text: "Qtde Inadimplencia",
        value: "qtdeinadimplencia",
        align: "right",
      },
      {
        text: "Valor Inadimplencia",
        value: "valorinadimplencia",
        align: "right",
      },
    ],
    statusItems: [
      { label: "Removido", value: "removed" },
      { label: "Em cancelamento", value: "canceling" },
      { label: "Ativo", value: "activated" },
      { label: "Interrompendo fornecimento", value: "interrupting" },
    ],
    editedIndex: -1,
    editedItem: {
      consumer_unit: "",
      percentage: 0,
      status: "activated",
    },
    defaultItem: {
      consumer_unit: "",
      percentage: 0,
      status: "activated",
    },
    eventName: "Envio",
    eventDate: "",
    loading_export: false,
    pag: {
      rowsPerPage: 50,
      // totalItems: 20
    },
  }),

  computed: {
    ...mapState("utility", ["fileItems", "itemLoading", "utility_file_id"]),
    ...mapGetters("utility", ["sumItemsPercentage"]),
    ...mapState(["user"]),
    formTitle() {
      return this.editedIndex === -1 ? "Novo" : "Editar";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions("utility", [
      "getUtilityFileItems",
      "deleteFileItem",
      "editFileItem",
      "addFileItem",
      "saveSent",
      "saveExport",
    ]),
    initialize() {
      eventBus.$on("utilityItemsDialog", async (utility_file) => {
        if (!utility_file.id) {
          console.error("not found utility_file_id");
          return;
        }
        this.dialog = true;
        this.utilityFile = utility_file;
        this.$store.commit("utility/setUtilityFileId", utility_file.id);
        let id = this.utility_file_id;
        if (!id) id = utility_file.id;
        await this.getUtilityFileItems(id).catch((err) => console.error(err));
      });
    },
    editItem(item) {
      this.editedIndex = this.fileItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog_edit = true;
    },
    dialogEvent() {
      this.dialog_event = true;
    },
    async saveEvent() {
      console.log(this.eventName, this.eventDate);
      try {
        let date = this.eventDate.split("/");
        console.log(date);
        date = date[2] + "-" + date[1] + "-" + date[0];
        console.log(this.eventName, date);
        let params = {
          utility_file_id: this.utility_file_id,
          name: this.eventName,
          date: date,
          history: this.utilityFile.history || [],
        };
        await this.saveSent(params);
        this.dialog_event = false;
      } catch (err) {
        console.error(err);
      }
    },

    deleteItem(item) {
      // const index = this.desserts.indexOf(item)
      confirm(
        "Tem certeza que deseja retirar da lista a Unidade Consumidora " +
          item.consumer_unit +
          "?",
      ) &&
        this.deleteFileItem({
          utility_file_id: this.utility_file_id,
          id: item.consumer_unit,
        }); //this.desserts.splice(index, 1)
    },

    close() {
      this.dialog_edit = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      let params = {
        utility_file_id: this.utility_file_id,
        ...this.editedItem,
      };
      if (this.editedIndex > -1) {
        //   Object.assign(this.desserts[this.editedIndex], this.editedItem)
        this.editFileItem(params);
      } else {
        this.addFileItem(params);
        //   this.desserts.push(this.editedItem)
      }
      this.close();
    },
    async _export(items) {
      this.loading_export = true;
      let data = [["UC", "CPF/CNPJ", "Quota"]];
      try {
        /* convert state to workbook */
        for (let i = 0; i < items.length; i++) {
          let _uc = items[i];
          console.log(
            "Processando " +
              (i + 1) +
              " | " +
              items.length +
              " | " +
              _uc.consumer_unit,
          );
          if (_uc.status === "removed" || _uc.percentage === 0) continue;
          // let uc = await getConsumerUnit(_uc.consumer_unit)
          // if(!uc.exists) {
          //     console.error('Unidade consumidora ' + _uc.id + ' não encontrada')
          //     continue
          // }
          data.push([_uc.consumer_unit, _uc.cpf, _uc.percentage]);
        }

        const ws = await XLSX.utils.aoa_to_sheet(data);
        const wb = XLSX.utils.book_new();

        const file = `${this.utilityFile.power_plant_id.toUpperCase()}_${
          this.utilityFile.expected_competence.split("-")[1]
        }_${this.utilityFile.expected_competence.split("-")[0]}`;
        // XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
        XLSX.utils.book_append_sheet(wb, ws, file);
        /* generate file and send to client */
        XLSX.writeFile(wb, file + ".xlsx");
        let params = {
          data: data,
          utility_file_id: this.utility_file_id,
          expected_competence: this.utilityFile.expected_competence,
          power_plant_id: this.utilityFile.power_plant_id,
          installation_number: this.utilityFile.installation_number,
          history: this.utilityFile.history || [],
          done_by: this.user.email,
        };
        await this.saveExport(params);
        this.loading_export = false;
      } catch (err) {
        console.error(err);
        this.loading_export = false;
      }
    },
    formatFileName(value) {
      if (!value) return "";
      const year = value.getYear();
      const month = value.getMonth() + 1;
      const day = value.getDay();
      const hour = value.getHours();
      const minute = value.getMinutes();
      return day + "" + month + "" + year + "" + hour + "" + minute;
    },
    getCompetenceMonthYear(competence) {
      const month = competence.split("-")[1];
      const year = competence.split("-")[0];
      switch (month) {
        case "01":
          return `JAN_${year}`;
        case "02":
          return `FEV_${year}`;
        case "03":
          return `MAR_${year}`;
        case "04":
          return `ABR_${year}`;
        case "05":
          return `MAI_${year}`;
        case "06":
          return `JUN_${year}`;
        case "07":
          return `JUL_${year}`;
        case "08":
          return `AGO_${year}`;
        case "09":
          return `SET_${year}`;
        case "10":
          return `OUT_${year}`;
        case "11":
          return `NOV_${year}`;
        case "12":
          return `DEZ_${year}`;
        default:
          throw new Error("Competência inválida");
      }
    },
  },
  filters: {
    formatFileItemStatus: function (value) {
      if (!value) return "";
      // console.log(value)
      // value = value.toString()
      switch (value) {
        case "removed":
          return "Removido";
        case "activated":
          return "Ativo";
        case "interrupting":
          return "Em Interrupção";
        case "interrupted":
          return "Interrompido";
        case "canceling":
          return "Em Cancelamento";
        case "canceled":
          return "Cancelado";
        default:
          return value;
      }
    },
    formatFileItemStatusColor: function (value) {
      if (!value) return "grey";
      // console.log(value)
      // value = value.toString()
      switch (value) {
        case "removed":
          return "black";
        case "activated":
          return "green";
        case "interrupting":
          return "#ffbf00";
        case "interrupted":
          return "#663366";
        case "canceling":
          return "#ffbf00";
        case "canceled":
          return "red";
        default:
          return "blue";
      }
    },
  },
};
</script>
